module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/128.02ad4c06.png";